import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  hours: number;
  minutes: number;
  seconds: number;
}
export const CountdownTimer = ({
  hours,
  minutes,
  seconds
}: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState({
    hours,
    minutes,
    seconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      if (timeLeft.seconds > 0) {
        setTimeLeft(prev => ({
          ...prev,
          seconds: prev.seconds - 1
        }));
      } else if (timeLeft.minutes > 0) {
        setTimeLeft(prev => ({
          minutes: prev.minutes - 1,
          seconds: 59,
          hours: prev.hours
        }));
      } else if (timeLeft.hours > 0) {
        setTimeLeft(prev => ({
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        }));
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  return <div className="flex justify-center items-center space-x-2 my-2" data-id="element-168">
      <div className="bg-gray-800 text-white px-3 py-2 rounded font-mono font-bold" data-id="element-169">
        {String(timeLeft.hours).padStart(2, '0')}
      </div>
      <span className="text-gray-800 font-bold" data-id="element-170">:</span>
      <div className="bg-gray-800 text-white px-3 py-2 rounded font-mono font-bold" data-id="element-171">
        {String(timeLeft.minutes).padStart(2, '0')}
      </div>
      <span className="text-gray-800 font-bold" data-id="element-172">:</span>
      <div className="bg-gray-800 text-white px-3 py-2 rounded font-mono font-bold" data-id="element-173">
        {String(timeLeft.seconds).padStart(2, '0')}
      </div>
    </div>;
};